import { SvgIcon } from "@mui/material"
import { CommonProps } from "@mui/material/OverridableComponent"


export const SchoolHighIcon = ({ style }: CommonProps) => {
  return (
    <SvgIcon viewBox="0 0 300 300" color="secondary" style={{...style, fontSize: "large"}}>
      <polygon points="150,15 258,77 258,202 150,265 42,202 42,77" />
    </SvgIcon>
  )
}

export const SchoolMiddleIcon = ({ style }: CommonProps) => {
  return (
    <SvgIcon viewBox="0 0 300 300" color="secondary" style={{ ...style, fontSize: "large" }}>
      <polygon points="150,15 285,150 150,285 15,150" />
    </SvgIcon>
  )
}

export const SchoolElementaryIcon = ({ style }: CommonProps) => {
  return (
    <SvgIcon viewBox="0 0 300 300" color="secondary" style={{ ...style, fontSize: "large" }}>
      <circle cx="150" cy="150" r="110" />
    </SvgIcon>
  )
}
